import { DDIProvision } from "callable-data-objects";
import { useTicket } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import {
  Button,
  Checkbox,
  Dimmer,
  Loader,
  Menu,
  Table,
} from "semantic-ui-react";

const MigrationBuildForm = () => {
  const { ticket, buildMigration, loading } = useTicket();
  const { migrationNumbers, ddis } = ticket.migrationRequest;

  return (
    <Fragment>
      <Dimmer active={loading}>
        <Loader />
      </Dimmer>
      <Menu>
        <Menu.Menu position='right'>
          <Menu.Item>
            <Button secondary onClick={buildMigration}>
              Build
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
      <Table compact stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>DDI</Table.HeaderCell>
            <Table.HeaderCell>Built</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {migrationNumbers.split("\n").map((s: string) => (
            <Table.Row>
              <Table.Cell width={14}>{s}</Table.Cell>
              <Table.Cell width={2}>
                <Checkbox
                  toggle
                  checked={
                    ddis &&
                    ddis.find((dp: DDIProvision) => dp.ddi.name === s) !==
                      undefined
                  }
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Fragment>
  );
};

export default MigrationBuildForm;
